/* XOOME sections — vanilla JS, re-initializable for the Shopify theme editor */
(function () {
  'use strict';

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.xm-reveal:not(.xm-bound)');
    if (!('IntersectionObserver' in window)) {
      els.forEach ? els.forEach(function (e) { e.classList.add('xm-in'); }) : null;
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('xm-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(els, function (el) {
      el.classList.add('xm-bound');
      io.observe(el);
    });
  }

  function initMarquees(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.xm-mq-track:not(.xm-bound), .xm-rvw-track:not(.xm-bound)'), function (track) {
      track.classList.add('xm-bound');
      track.innerHTML += track.innerHTML; /* duplicate content for seamless loop */
    });
  }

  function initTabs(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.xm-tabs:not(.xm-bound)'), function (tabs) {
      tabs.classList.add('xm-bound');
      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('.xm-tab');
        if (!btn) return;
        tabs.querySelectorAll('.xm-tab').forEach(function (t) { t.classList.remove('xm-active'); });
        btn.classList.add('xm-active');
        var img = document.getElementById(tabs.getAttribute('data-image-target'));
        if (img && btn.getAttribute('data-image')) img.src = btn.getAttribute('data-image');
      });
    });
  }

  function initAccordions(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-xm-acc]:not(.xm-bound)'), function (acc) {
      acc.classList.add('xm-bound');
      acc.addEventListener('click', function (e) {
        var btn = e.target.closest('.xm-acc-btn');
        if (!btn) return;
        var item = btn.parentElement;
        var body = item.querySelector('.xm-acc-body');
        var isOpen = item.classList.contains('xm-open');
        acc.querySelectorAll('.xm-acc-item').forEach(function (i) {
          i.classList.remove('xm-open');
          i.querySelector('.xm-acc-body').style.maxHeight = null;
          i.querySelector('.xm-acc-btn').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('xm-open');
          body.style.maxHeight = body.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initBuybars(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.xm-buybar:not(.xm-bound)'), function (bar) {
      bar.classList.add('xm-bound');
      var offset = parseInt(bar.getAttribute('data-offset') || '600', 10);
      var onScroll = function () {
        bar.classList.toggle('xm-show', window.scrollY > offset);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  function initAll(root) {
    initReveals(root); initMarquees(root); initTabs(root); initAccordions(root); initBuybars(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
